import { clsx } from 'clsx';

type Props = { children: React.ReactNode; className?: string };

export function Kbd({ children, className }: Props) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center px-1.5 py-0.5',
        'text-[11px] font-medium font-mono',
        'bg-bg-panel border border-border-strong rounded text-text-muted',
        className,
      )}
    >
      {children}
    </span>
  );
}
